<template>
  <div class="d-flex">
    <v-btn
      v-if="actions.length"
      class="mr-2"
      depressed
      color="primary"
      @click="makeAction"
    >
      Podejmij działanie
    </v-btn>

    <v-btn
      v-if="downloadReportPermitted"
      class="mr-2"
      depressed
      color="secondary"
      @click="$emit('print-report')"
    >
      Pobierz raport
    </v-btn>

    <v-btn
      v-if="metricsPermitted"
      class="mr-2"
      depressed
      color="secondary"
      link
      :to="{ name: 'project-metrics', params: { id: projectId } }"
    >
      Metryka
    </v-btn>

    <v-btn
      v-if="assignKIWPermitted"
      class="mr-2"
      depressed
      color="primary"
      :to="{ name: 'archive-project-create-kiw', params: { id: projectId } }"
    >
      Wnioskuj o numer KIW
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters('auth', ['checkUserPermissions']),

    downloadReportPermitted() {
      const availability = [
        'admin_director',
        'chief',
        'graphic',
        'editor',
        'project_manager',
        'print_coordinator',
        'other',
      ];
      return this.checkUserPermissions(availability);
    },
    metricsPermitted() {
      const availability = [
        'admin_director',
        'chief',
        'department_director',
        'user',
        'graphic',
        'editor',
        'project_manager',
        'print_coordinator',
        'other',
      ];
      return this.checkUserPermissions(availability);
    },
    assignKIWPermitted() {
      const availability = [
        'admin_director',
        'chief',
        'department_director',
        'user',
        'graphic',
        'editor',
        'project_manager',
        'print_coordinator',
        'guard',
      ];
      return this.checkUserPermissions(availability);
    },
  },

  methods: {
    ...mapActions('dialog', ['showDialog']),
    makeAction() {
      this.showDialog({
        header: 'Potwierdzenie działania',
        text: 'Masz do podjęcia działania w projekcie.',
        component: 'MakeAction',
        props: {
          id: this.projectId,
          actions: this.actions,
        },
      });
    },
  },
};
</script>
